const Tooltip = {
   baseStyle: {
      fontSize: 'md',
   },
   defaultProps: {
      openDelay: 50,
      shouldWrapChildren: true,
      closeOnMouseDown: true,
   },
};

export default Tooltip;
